/**
 * Plain-language text for an HTTP error status, for when the server sent no message of its own.
 * One place for every API client (instead of "Request failed (502)" scattered through screens).
 */
export function statusMessage(status: number): string {
  if (status === 0) return 'Couldn’t reach the server. Check your connection and try again.';
  if (status === 400 || status === 422) return 'That wasn’t accepted. Check the values and try again.';
  if (status === 401) return 'Your session has ended. Sign in again.';
  if (status === 403) return 'You don’t have permission to do that.';
  if (status === 404) return 'That isn’t available here.';
  if (status === 409) return 'Something changed in the meantime. Reload and try again.';
  if (status === 413) return 'That’s too large to send.';
  if (status === 429) return 'Too many attempts. Wait a minute and try again.';
  if (status === 502 || status === 504) return 'The home didn’t answer in time. Try again in a moment.';
  if (status === 503) return 'This isn’t available right now. Try again in a moment.';
  if (status >= 500) return 'Something went wrong on the server. Try again in a moment.';
  return `Something went wrong (${status}).`;
}
